export function chart(ctx) {
    return {
        properties: {
            series:      ['#e91e63', '#1976d2'],
            point_count: 10,
            min: 0, max: 100,
        },
        styles: {
            main: {
                ...ctx.pretty,
                // ctx.BORDER doesn't exist on this theme's context (only
                // hasp-dark/hasp-light's buildContext export that alias) —
                // was silently resolving to undefined. Fixed to the real
                // context field; matches lv_theme_material.c:543
                // (chart_series_bg line_color = COLOR_BG_BORDER).
                grid_color: ctx.COLOR_BG_BORDER,
                // type/hdiv/vdiv/line_width/point_size removed: identical to
                // (or, for line_width, now-corrected-to-equal) the schema
                // defaults, which already match firmware
                // (lv_theme_material.c:546 chart_series line_width=LV_DPX(3)=3;
                // the previous override of 2 here was INCORRECT).
            },
        },
    };
}
